import React, { Component } from "react"
import Authenticated from "../../lib/Authenticated"
import ItemSetting from "./ItemSetting"

class HomeSettings extends Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  termsText = () => this.isAdmin
    ? 'Manage Terms and Conditions of my organization'
    : 'Manage generic Terms and Conditions'

  render() {
    return (
      <div className="homeSettingContainer">

        <ItemSetting to='/settings/terms-and-conditions'
          title='Terms and Conditions'
          desc={ this.termsText() }
          iconName='cog'
          size=''
        />

        <ItemSetting to='/settings/ages'
          title='Age settings'
          desc='Manage the ages of loan applications in each country'
          iconName='user'
          size=''
        />

        { this.isAdmin && <ItemSetting to='/settings/loan-verification'
          title='Loan verification type'
          desc='Configure the type of verification to apply on loans'
          iconName='credit-card'
          size=''
        />}

        <ItemSetting to='/settings/customers-data'
          title='Customers data'
          desc={`Configure ${ this.isAdmin ? '' : 'default' } customer info and documents`}
          iconName='book'
          size=''
        />

        { this.isAdmin && <ItemSetting to='/settings/qrcodes'
          title='QR codes'
          desc='Manage QR codes for sideloading devices'
          iconName='qrcode'
          size=''
        />}

        { this.isAdmin && <ItemSetting to='/settings/base-currency'
          title='Base currency'
          desc='Configure base currency for transactions'
          iconName='usd'
          size=''
        />}

        { this.isAdmin && <ItemSetting to='/settings/accounting'
          title='Accounting Setting'
          desc='Various configurations for accounting'
          iconName='money'
          size=''
        />}
      </div>
    )
  }
}

export default HomeSettings



// WEBPACK FOOTER //
// ./src/components/Settings/HomeSettings.js